import React from 'react';
import { useSelector } from 'react-redux';
import { selectStoreCount } from 'core/selectors/app';
import { selectUserName } from 'core/selectors/user';
import SlideMessage from '../SlideMessage/SlideMessage';
import SlideCounter from '../SlideCounter/SlideCounter';
import { WELCOME_MESSAGE } from '../SlideMessage/utils/constants';

import orgConfig from 'org/configs/org.config';

import config from './configs';

function Welcome({ handleWelcomeDoneClick, sequenceValue, stepsData }) {
  const storeCount = useSelector(selectStoreCount);
  const userName = useSelector(selectUserName);
  const { getWelcomeText, welcomeCTAText, getWelcomeTitleText } = config;
  const { earnType } = orgConfig;
  const welcomeText = getWelcomeText(storeCount, earnType);
  const welcomeTitleText = getWelcomeTitleText(userName);

  return (
    <div className="mn_slide mn_slideWelcome">
      <SlideMessage step={WELCOME_MESSAGE} />
      <div className="mn_content">
        <SlideCounter stepsData={stepsData} />
        <div className="mn_gap" />
        <div className="mn_logo" />
        <h2>{welcomeTitleText}<span className="mn_dot">.</span></h2>
        <p>{welcomeText}</p>
        <div className="mn_bottomContent">
          <button
            className="mn_button mn_stepButton mn_stepWelcomeDone"
            onClick={handleWelcomeDoneClick}
            data-sequence-value={sequenceValue}
          >
            {welcomeCTAText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
